<template>
    <div class="text-center">
        <v-progress-circular :indeterminate="indeterminate" :size="size||32"></v-progress-circular>
        <div>{{ text || $t('loading.text') }}</div>
    </div>
</template>
<script>
export default {
    props:['indeterminate', 'size', 'text']
}
</script>


